/**
 * @generated SignedSource<<97d0908d6110f0ac448700de526bb7ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TriggerIngestionInput = {
  topicSlug: string;
};
export type TopicListTriggerIngestionMutation$variables = {
  input: TriggerIngestionInput;
};
export type TopicListTriggerIngestionMutation$data = {
  readonly triggerIngestion: {
    readonly message: string | null | undefined;
    readonly success: boolean;
    readonly userErrors: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly field: string | null | undefined;
      readonly message: string;
    }>;
  };
};
export type TopicListTriggerIngestionMutation = {
  response: TopicListTriggerIngestionMutation$data;
  variables: TopicListTriggerIngestionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TriggerIngestionPayload",
    "kind": "LinkedField",
    "name": "triggerIngestion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TopicListTriggerIngestionMutation",
    "selections": (v2/*: any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TopicListTriggerIngestionMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "14752aed4afe4b49d10d6ad602a2bf1b",
    "id": null,
    "metadata": {},
    "name": "TopicListTriggerIngestionMutation",
    "operationKind": "mutation",
    "text": "mutation TopicListTriggerIngestionMutation(\n  $input: TriggerIngestionInput!\n) {\n  triggerIngestion(input: $input) {\n    success\n    message\n    userErrors {\n      field\n      message\n      code\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2ddc0088f794cd84879614efd59a3cc4";

export default node;
